import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Shield, Zap, Building2, Users, Trophy, BookOpen } from 'lucide-react';

const AboutPage = () => (
  <div className="max-w-7xl mx-auto px-4 py-12">
    <div className="space-y-12">
      {/* Hero Section */}
      <div className="relative h-64 rounded-xl overflow-hidden mb-12">
        <img
          src="/assets/energy.jpg"
          alt="Escort Energi Office"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <h1 className="text-4xl font-bold text-white">About Escort Energi Limited</h1>
        </div>
      </div>

      {/* Company Overview */}
      <Card>
        <CardContent className="p-6">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-2xl font-semibold mb-4">Our Story</h2>
              <p className="text-gray-600 mb-4">
                Founded in 1997 in Greater Accra, Ghana, Escort Energi Limited has established itself as a leading electrical supply and equipment trading services company. With over 25 years of experience, we've earned a reputation for excellence and professionalism by consistently exceeding standards and building sustainable relationships with our clients.
              </p>
              <p className="text-gray-600">
                Our team consists of technically skilled and highly dedicated personnel working cohesively to promote value-added solutions with competitive pricing structures tailored to your needs.
              </p>
            </div>
            <div className="relative h-64 rounded-lg overflow-hidden">
              <img
                src="/assets/7.jpg"
                alt="Company History"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Vision & Mission */}
      <div className="grid md:grid-cols-2 gap-8">
        <Card>
          <CardHeader>
            <CardTitle>Our Vision</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <Shield className="h-5 w-5 mt-1 text-blue-500" />
                <span>To be recognized as a dependable and reliable distributor of electrical power and control products</span>
              </li>
              <li className="flex items-start gap-2">
                <Zap className="h-5 w-5 mt-1 text-blue-500" />
                <span>To compete proactively in all facets of the marketplace through constant improvement</span>
              </li>
              <li className="flex items-start gap-2">
                <Building2 className="h-5 w-5 mt-1 text-blue-500" />
                <span>To maintain our position as a family-owned business that prioritizes customer satisfaction</span>
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Our Mission</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-gray-600">
              Escort Energi Ltd is committed to providing the highest quality products and service exceeding our clients' expectations. We continuously expand our equipment and facilities while engaging in training and certification programs to serve customers with utmost excellence and professionalism.
            </p>
            <div className="mt-4 p-4 bg-blue-50 rounded-lg">
              <p className="text-blue-800 font-semibold text-center">
                "Delivering Results, Exceeding Expectations"
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Our Team Section */}
      <div className="bg-gray-50 py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8">Our Team</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card>
              <CardContent className="p-6 text-center">
                <div className="mx-auto w-24 h-24 mb-4 rounded-full bg-blue-100 flex items-center justify-center">
                  <Users className="h-12 w-12 text-blue-500" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Technical Team</h3>
                <p className="text-gray-600">
                  Highly skilled professionals undergo annual technical training to stay updated on the latest electrical products and technologies.
                </p>
                <ul className="mt-4 space-y-2 text-sm text-gray-500">
                  <li className="flex items-center justify-center gap-2">
                    <Trophy className="h-4 w-4 text-blue-400" />
                    Continuous skill enhancement
                  </li>
                  <li className="flex items-center justify-center gap-2">
                    <BookOpen className="h-4 w-4 text-blue-400" />
                    Yearly product training
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <div className="mx-auto w-24 h-24 mb-4 rounded-full bg-green-100 flex items-center justify-center">
                  <Shield className="h-12 w-12 text-green-500" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Expertise Areas</h3>
                <p className="text-gray-600">
                  Our team specializes in diverse electrical and technical domains, from industrial installations to advanced cybersecurity.
                </p>
                <ul className="mt-4 space-y-2 text-sm text-gray-500">
                  <li>Industrial Electrical Wiring</li>
                  <li>Renewable Energy Systems</li>
                  <li>Data Center Infrastructure</li>
                  <li>Cybersecurity Solutions</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <div className="mx-auto w-24 h-24 mb-4 rounded-full bg-purple-100 flex items-center justify-center">
                  <Zap className="h-12 w-12 text-purple-500" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Service Commitment</h3>
                <p className="text-gray-600">
                  Dedicated to delivering outstanding results with a focus on customer satisfaction, innovation, and professional excellence.
                </p>
                <div className="mt-4 p-3 bg-purple-50 rounded text-sm text-purple-700">
                  "Delivering Results, Exceeding Expectations"
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AboutPage;